import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '../Components/Typography';
import TextField from '../Components/TextField';
import Snackbar from '../Components/Snackbar';
import Button from '../Components/Button';

export const ContactUsEmail = () => {
	const [open, setOpen] = React.useState(false);
	const [subscribeEmail, setSubscribeEmail] = React.useState('');

	const handleChange = (e: any) => {
		setSubscribeEmail(e.target.value);
	};

	const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		setOpen(true);
		console.log(subscribeEmail);
	};

	const handleClose = () => {
		setOpen(false);
		console.log('Closed');
		setSubscribeEmail('');
		console.log(subscribeEmail);
	};

	return (
		<Box
			component="section"
			sx={{
				display: 'flex',
				overflow: 'hidden',
				bgcolor: 'secondary.light',
				mb: 4,
			}}
			id="contactus"
		>
			<Container
				component="section"
				sx={{
					mt: 10,
					mb: 15,
					position: 'relative',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<Typography
					variant="h4"
					marked="center"
					align="center"
					component="h2"
					paddingBottom={10}
				>
					Contact Us
				</Typography>

				<Grid container>
					<Grid item xs={12} md={6} sx={{ zIndex: 1 }}>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'center',
								bgcolor: 'warning.main',
								py: 8,
								px: 3,
							}}
						>
							<Box
								component="form" //Input Form
								onSubmit={handleSubmit}
								sx={{ maxWidth: 400 }}
							>
								<Typography
									variant="h2"
									component="h2"
									gutterBottom
								>
									Be The First...
								</Typography>
								<Typography variant="h5">
									Receive the latest deals first, exclusive to
									subscribers.
								</Typography>
								<TextField
									onChange={handleChange}
									noBorder
									placeholder="Your email"
									name="email"
									value={subscribeEmail}
									type="email"
									variant="standard"
									sx={{ width: '100%', mt: 3, mb: 2 }}
									required={true}
									autoComplete="false"
								/>
								<Button
									type="submit"
									color="primary"
									variant="contained"
									sx={{ width: '100%' }}
									// disabled={true}
								>
									Keep me updated
								</Button>
							</Box>
						</Box>
					</Grid>
					<Grid
						item
						xs={12}
						md={6}
						sx={{
							display: { md: 'block', xs: 'none' },
							position: 'relative',
						}}
					>
						<Box
							sx={{
								position: 'absolute',
								top: -67,
								left: -67,
								right: 0,
								bottom: 0,
								width: '100%',
								background:
									'url(/static/themes/onepirate/productCTAImageDots.png)',
							}}
						/>
						<Box
							component="img"
							src="https://images.unsplash.com/photo-1527853787696-f7be74f2e39a?auto=format&fit=crop&w=750"
							alt="call to action"
							sx={{
								position: 'absolute',
								top: -28,
								left: -28,
								right: 0,
								bottom: 0,
								width: '100%',
								maxWidth: 600,
							}}
						/>
					</Grid>
				</Grid>
				<Snackbar
					open={open}
					closeFunc={handleClose}
					message="Thank you, we will be keeping you up to date with our latest information."
				/>
			</Container>
		</Box>
	);
};
